const React = require("react");
const T = React.PropTypes; 

require("./PdfButton.less");

const PdfButton = React.createClass({
    propTypes : { 
        Save: T.func.isRequired
    }, 
    render () {
        return (<span className={"cs-pdf"}><button className={"btn btn-success cs-pdfButton"} onClick={this.props.Save}>
                <span className={"glyphicon glyphicon-download-alt"}></span> Save</button></span>); 
    }
});

module.exports = PdfButton; 


// WEBPACK FOOTER //
// ./src/components/SurveySummary/PdfButton/PdfButton.jsx